<template>
  <div class="min-h-screen bg-gray-200 dark:bg-gray-800 flex justify-center overflow-hidden">
    <div class="w-full max-w-6xl">
      <!-- Header con sfondo full-width -->
      <div class="bg-white dark:bg-gray-900 shadow-md fixed top-0 left-0 right-0">
        <header class="py-4 px-6 flex justify-between items-center max-w-6xl mx-auto">
          <ApplicationLogo class="h-12 w-12"></ApplicationLogo>
          <img :src="`/images/loghi-clienti/${ customer.slug }.png`" :alt="customer.name" class="h-12">
          <Link
              :href="route('logout')"
              method="post"
              as="button"
              class="bg-red-500 dark:bg-red-700 text-white w-10 h-10 flex items-center justify-center rounded-full font-bold"
          >
              U
          </Link>
        </header>
      </div>

      <!-- Spazio per non coprire il contenuto sotto l'header -->
      <div class="h-20"></div>

      <!-- Corpo -->
      <div class="p-6 flex flex-col lg:flex-row items-start gap-6">
        <!-- Box di benvenuto -->
        <div class="bg-white dark:bg-gray-900 shadow-md rounded-lg p-6 w-full lg:w-1/3 flex flex-col">
          <div class="flex items-center gap-4">
            <div class="w-16 h-16 bg-red-500 dark:bg-red-700 text-white flex items-center justify-center text-2xl font-bold rounded-full">
              U
            </div>
            <div>
              <h2 class="text-xl text-gray-700 dark:text-gray-300">Bentornato,</h2>
              <p class="text-lg font-bold text-gray-900 dark:text-gray-100">{{ user.name }}!</p>
            </div>
          </div>
          <hr class="my-4 border-gray-300 dark:border-gray-700">
        </div>

        <!-- Griglia di moduli (allineata a destra) -->
        <div class="w-full lg:w-2/3 lg:justify-end justify-space-around">
          <div class="flex gap-6 flex-wrap lg:flex-row-reverse">
            <div
              v-for="module in modules"
              :key="module.id"
              class="bg-white dark:bg-gray-900 shadow-md rounded-lg p-6 w-40 h-40 flex flex-col items-center justify-center text-center cursor-pointer hover:shadow-lg transition"
            >
              <img :src="module.icon" alt="Icona" class="w-12 mb-2">
              <p class="text-lg font-semibold text-gray-900 dark:text-gray-100">{{ module.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link, usePage } from '@inertiajs/vue3';
import ApplicationLogo from '@/Components/ApplicationLogo.vue';

export default {
  components: {
    ApplicationLogo,
    Link
  },
  props: ['user', 'customer', 'modules']
};
</script>